<template>
    <div class="main-form">
        <div>
            <StepNumber
                stepNum="4"
                totalSteps="5"
            ></StepNumber>
            <div class="main-form_info">
                <!-- TITULARES -->
                <div>
                    <TitleAndExplanation 
                        :title = "$store.state.newTexts.step_datos_titular[0].title"
                        :explanation = "$store.state.newTexts.step_datos_titular[0].explanation"
                    ></TitleAndExplanation>
                    <!-- Listado Titulares -->
                    <TitularComponent 
                        v-for = "(titular, index) in $store.state.prescoringData.titulares" 
                        :key = "index" 
                        :numTitular = "titular.numTitular" 
                    />
                    <!-- Añadir/Eliminar titular -->
                    <div class="botones-titular">
                        <button 
                            class="button secondary" 
                            @click="addTitular" 
                            :disabled="$store.state.prescoringData.titulares.length >= 4"
                        >
                            <span style="font-size: 24px; margin-right: 4px">+</span>Añadir titular
                        </button>
                        <button 
                            class="button secondary" 
                            @click="delTitular" 
                            :disabled="$store.state.prescoringData.titulares.length <= 1"
                        >
                            <span>Borrar titular</span>
                        </button>
                    </div>
                </div>
                <!-- INGRESOS-->
                <InputSlider
                    :minValue = 0
                    :maxValue = 20000
                    :step = 10
                    :currentValue = "$store.state.prescoringData.total_ingresos??0"
                    :title="$store.state.newTexts.step_datos_titular[1].title"
                    :explanation="$store.state.newTexts.step_datos_titular[1].explanation"
                    @valueChanged = "(value) => handleValueChanged('total_ingresos',value)"
                ></InputSlider>            
            </div>
        </div>
        <NavegationButtons 
            :nextStep = "nextStep"
            :nextStepButtonActive = "canContinue"
            nextStepButtonText = "Continuar"
            backStepButtonText = "Atrás"
        ></NavegationButtons>
    </div>
</template>

<script>
import StepNumber from '../common/StepNumber.vue'
import TitleAndExplanation from '../common/TitleAndExplanation.vue'
import NavegationButtons from '../common/NavegationButtons.vue'
import InputSlider from '../common/InputSlider.vue'
import TitularComponent from '../common/Titular.vue'

export default {
    name: 'step_datos_titular',
    components: {
        StepNumber,
        TitleAndExplanation,
        NavegationButtons,
        InputSlider,
        TitularComponent
    },
    computed: {
        nextStep(){
            return 'step_datos_financieros';
        },
        canContinue(){
            const { titulares, total_ingresos } = this.$store.state.prescoringData;
            let titularesOk = false;
            if(titulares.length > 0){
                titularesOk = titulares.every(titular => {
                    return titular.edad !== null && titular.edad !== '' &&
                        titular.contrato !== null && titular.contrato !== '' &&
                        titular.antiguedad !== null && titular.antiguedad !== '' && titular.antiguedad >= 0 && titular.antiguedad <= 720;
                });
            }
            return total_ingresos !== null && total_ingresos > 0 && titularesOk;
        }
    },
    methods: {
        handleValueChanged(field, value){
            this.$store.commit('updatePrescoringData', { field, value });
        },        
        addTitular(){
            if (this.$store.state.prescoringData.titulares.length < 4) { 
                this.$store.commit('addTitular', {titularIndex:this.$store.state.prescoringData.titulares.length});
            }
        },
        delTitular(){
            if (this.$store.state.prescoringData.titulares.length > 1) { 
                this.$store.commit('removeTitular');
            }
        }
    }
}
</script>

<style>
    .botones-titular{
        display: flex;
        margin-top: 20px;
    }
    .botones-titular .button.secondary{ 
        padding: 0;
        margin-left: 0;
    }
    .button+.button {
        margin-left: calc(var(--spacer)* 1);
    }

</style>








